exports.parse = function (url) {
  var query
  var ret
  if (url) {
    ret = {}
    query = url.slice(url.indexOf('?') + 1)
    if (!query) {
      return {}
    }

    query = query.split('?')[0]
    query.split('&').forEach(function (pair) {
      var splited = pair.split('=')
      if (splited[0]) {
        if (splited[1]) {
          ret[splited[0]] = decodeURIComponent(splited[1])
        } else {
          ret[splited[0]] = true
        }
      }
    })
  } else {
    ret = {}
  }

  return ret
}

exports.append = function (origin, obj) {
  var splited = origin.split('?')
  var base = splited[0]

  var qs =  splited[1] ? ('?' + splited[1]) : ''


  var params = exports.parse(qs)
  for (var k in obj) {
    params[k] = obj[k]
  }

  return base + '?' + exports.stringify(params)
}

exports.stringify = function (data) {
  var result = []
  for (var key in data) {
    if (data[key] !== undefined) {
      result.push(key + '=' + encodeURIComponent(data[key]))
    }
  }
  return result.join('&')
}

exports.delete = function (origin, key) {
  var splited = origin.split('?')
  var base = splited[0]
  var params = '?' + splited[1]
  params = exports.parse(params)
  delete params[key]
  for (var prop in params) {
    if (params.hasOwnProperty(prop)) {
      return base + '?' + exports.stringify(params)
    }
  }
  return base
}

if (process.browser) {
  exports.query = exports.parse(location.search)
} else {
  exports.query = {}
}


//////////////////
// WEBPACK FOOTER
// ./~/pn-qs/index.js
// module id = 1914
// module chunks = 148